<template>
    <span>
    <div class="g-participant" v-if="groupLogOpenVoList&&groupLogOpenVoList.length">
        <a href="javascript:;" class="g-rules" @click="bindGoRule()"></a>
        <div class="g-participant-title">
            <h4>以下小伙伴正在发起团购，您可以直接参与</h4>
        </div>	
        <div class="g-participant-item">

            <div class="g-item" v-for="item in groupLogOpenVoList">
                <div class="item-img"><img :src="getAvatar(item.avatarUrl)"></div>
                <a href="javascript:;" class="item-link" @click="goJoinGroup(item)">
                    <dl class="item-name">
                        <dt class="item-more">
                            <span class="g-user">{{item.memberName}}</span>
                            <span class="g-number">还差<em>{{item.requireNum - item.joinedNum}}</em>人成团</span>
                        </dt>
                        <dd class="item-more">
                            <span class="g-state">正在开团中</span>
                            <span class="g-time">剩余<time class="J-join-count-down"
                                                         :data-end-time="getEndTime(item.endTime)"></time> 结束</span>
                        </dd>
                    </dl>
                    <a href="javascript:;" class="goto-btn">去参团</a>
                </a>	
            </div>
        </div>
    </div>


    </span>
</template>
<script>
    var shopingIScrollInstance;
    export default {
        props: {
            groupLogOpenVoList: {
                type: Array,
                required: false
            }
        },
        data()
        {
            return {
                //默认头像地址
                defaultAvatar: "../images/avatar_seller.gif",
                //是否显示团购说明
                show: false,
                first: true,
                detailIscrollWrapH: 375
            }
        },
        mounted(){

            $(".J-join-count-down").ncCountDown({

                cndays:"",
                cnminutes:"",
                cnallHours:'',
                cnhours:'',
                cnseconds:'',
                unitDay: "天",
                unitHour: ":",
                unitMinute: ":",
                unitSecond: "",
                warp: "em",
                hideDay: false,
                end: function() {
                    Nc.go()
                }
            });
        } ,
        methods: {

            //去除无关的touch事件
            excludeTouch: function (event) {
                event.preventDefault();
                return false;
            },

            getAvatar(avatarUrl)
            {
                return avatarUrl ? avatarUrl : this.defaultAvatar
            }
            ,
            getEndTime(time)
            {
                var _currTime = Date.parse(new Date());
                return parseInt((time - _currTime) / 1000)
            }
            ,
            goJoinGroup(info)
            {
                this.$emit('gojoingroup', info)
            }
            ,
            /**
             * 跳转到团购规格
             */
            bindGoRule : function () {
                this.$emit('gogrouprule')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/group-detail-join/group-detail-join.vue